/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsTestimonials = {
    init: function ($section) {
      const $testimonialSlider = $section.find('[data-slider]');

      let $carousel = $testimonialSlider.flickity({
        wrapAround: true,
        initialIndex: 1,
        prevNextButtons: true,
        pageDots: false,
        watchCSS: true,
        arrowShape: arrowShape
      });

      let flkty = $testimonialSlider.data('flickity');

      // grab Flickity’s built-in arrows
      let $prevArrow = $carousel.find('.flickity-prev-next-button.previous');
      let $nextArrow = $carousel.find('.flickity-prev-next-button.next');

      function updateArrows() {
        var lastIndex = flkty.slides.length - 1;

        if (flkty.selectedIndex === 0) {
          // at first slide → only show NEXT
          $prevArrow.hide();
          $nextArrow.show();
        } else if (flkty.selectedIndex === lastIndex) {
          // at last slide → only show PREV
          $prevArrow.show();
          $nextArrow.hide();
        } else {
          // in between → choose ONE (example: always show NEXT)
          $prevArrow.hide();
          $nextArrow.show();
        }
      }

      // run once on init
      updateArrows();

      // update on slide change
      flkty.on('select', updateArrows);

      // Resize flickity when the slider is settled
      $testimonialSlider.on('settle.flickity', function () {
        $testimonialSlider.flickity('resize');
      });

      $section.on('click', '.testimonial__nav--prev', function () {
        $testimonialSlider.flickity('previous');
      });

      $section.on('click', '.testimonial__nav--next', function () {
        $testimonialSlider.flickity('next');
      });
      
    },
    blockSelect: function ($section, blockId) {
      const $testimonialSlider = $section.find('[data-slider]');

      const slideIndex = $('#shopify-section-' + blockId).data('index');

      $testimonialSlider.flickity('select', slideIndex);
    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
      $('.testimonial__nav--prev').off();
      $('.testimonial__nav--next').off();
    }
  }

  /******/
})()
  ;